import { useState, useCallback, useEffect } from 'react';
import LocaleSwticher from './LocaleSwitcher';
import {useTranslation} from "react-i18next";
import i18n from "locales/i18n";
import { Link } from 'react-router';

export default function Header(props){

  const [isHovering, setIsHovering] = useState(false);
  const [showMoblieMenu, setShowMobileMenu] = useState(false);
  const [mobileIndex, setMobileIndex] = useState([false, false, false, false]);
  const [subIndex, setSubIndex] = useState(-1);
  const [titleBg, setTitleBg] = useState(false);

  const {t} = useTranslation();
  const locale = i18n.language ?? 'ko';

  const menuNames = [
    {name:t('menu.main-about'), href:'/corporation'},
    {name:t('menu.main-partners'), href:'/partners'},
    {name:t('menu.main-solutions'), href:'/solutions'},
    {name:t('menu.main-projects'), href:'/projects'},
  ];

  const subMenuNames = [
    [
      {name:t('menu.sub-corporation'), href:'/corporation'},
      {name:t('menu.sub-greetings'), href:'/corporation/greetings'},
      {name:t('menu.sub-certification'), href:'/corporation/certifications'},
      //{name:t('menu.sub-location'), href:'/corporation/location'}
    ],
    [
      {name:t('menu.sub-partners'), href:'/partners'},
    ],
    [      
      {name:t('menu.sub-business'), href:'/solutions/'},
      {name:t('menu.sub-inverters'), href:'/solutions/inverters'},
      {name:t('menu.sub-modules'), href:'/solutions/modules'},
      {name:t('menu.sub-monitoring'), href:'/solutions/monitoring'},
      {name:t('menu.sub-optimizers'), href:'/solutions/optimizers'},
      {name:t('menu.sub-o_m'), href:'/solutions/onm'},
      {name:t('menu.sub-repowering'), href:'/solutions/repowering'}
    ],
    [
      {name:t('menu.sub-references'), href:'/projects'}
    ]
  ];
  const logo = t('common.company-name')

  const handleMouse = useCallback((isHovering) => {
    setIsHovering(isHovering)
  }, [setIsHovering]);
  const handleMenuClick = useCallback(() =>setShowMobileMenu((prev) => !prev), [setShowMobileMenu]);
  const handleClose = useCallback(() => setShowMobileMenu(false), [setShowMobileMenu]);
  const handleMobileMenu = useCallback((index)=>{ 
    const current = [...mobileIndex]
    current[index] = !current[index];
    setMobileIndex(current);
  }, [setMobileIndex, mobileIndex]);
  const handleSubMenu = useCallback((index)=>{setSubIndex(index);}, [setSubIndex]);
  //const handleHide = useCallback((index)=> setMobileIndex(index), [setMobileIndex]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 30 ) setTitleBg(true);
      else setTitleBg(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const mainMenus = menuNames.map((menu, index) =>{
    let len = index===2? 'w-[180px]':'w-[112px]';
    if(locale === 'ko'){
      len = 'w-[112px]';
    }
    return (
      <li key={menu.name} className={`inline-block ${len} text-center hover:text-hover ${subIndex===index&&isHovering? 'text-hover':''}`}
        onMouseOver={()=>handleSubMenu(index)}>
        <Link to={menu.href}>{menu.name}</Link>
      </li>
    );
  });

  const subMenus = subMenuNames.map((menus, index) =>{
    let len = index===2? 'w-0 lg:w-[180px]':'w-0 lg:w-[112px]';
    if(locale === 'ko'){
      len = 'w-0 lg:w-[112px]';
    }
    return (
      <li key={`pc-sub-${index}`} className={`inline-block ${len} text-center`}
        onMouseOver={()=> handleSubMenu(index)}>
        <ul className="flex flex-col justify-start">
        {menus.map(menu=>{
          return (
            <li key={menu.name} className='my-1 text-center'>
              <Link className="text-gray-600 hover:text-black hover:font-semibold" to={menu.href}>{menu.name}</Link>
            </li>
          );
        })}
        </ul>
      </li>
    );
  });

  const mobileMenus = menuNames.map((menu, index)=>{
    return (
      <li key={menu.name} className={`overflow-hidden text-start`}>
        <div className='flex justify-between py-4 border-[0.5px] border-b-[#b7b7b7] border-t-transparent border-l-transparent border-r-transparent'>
          <p className="mx-1.5 text-lg font-semibold text-start" 
            onClick={()=>handleMobileMenu(index)}>{menu.name}</p>
          <div className='mx-1.5' onClick={()=>handleMobileMenu(index)}>{mobileIndex[index]?
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#303030">
              <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/></svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#303030">
              <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
            </svg>
          }
          </div>
        </div>
        
        <ul id={`sub-${menu.name}`} 
          className={`${mobileIndex[index]? 'h-full mt-4 mb-4 mx-1.5':'h-0'}`}>
          {subMenuNames[index].map(subMenu=>{
            return (
              <li key={subMenu.name} className='my-1.5 text-black'>
                <Link to={subMenu.href} onClick={handleClose} className='text-sm text-gray-600'>{subMenu.name}</Link>
              </li>
            );
          })}
        </ul>
      </li>
    );
  });
  return (
    <header>
      <div className={`w-screen min-w-0 fixed inset-x-0 top-0 z-10 group flex-col items-center  ${isHovering||subIndex!==-1 ? "menu-hover" : ""}`}
        onMouseLeave={()=>{handleMouse(false);setSubIndex(-1);}}>
        <div id="main-div"  
            className={`flex justify-center w-screen lg:transition lg:duration-700 group-[.menu-hover]:bg-[#FFFFFFF0] ${titleBg? 'bg-[#FFFFFFF0] h-20 text-black':'text-white h-28'}`}>
          <div className={`flex w-screen min-w-0 items-center py-10 px-mobile lg:px-0 lg:w-[1200px] justify-between group-[.menu-hover]:text-black `}>
            <div className="">
              <Link to="/" className="text-2xl font-bold ">{logo}</Link>
            </div>
            <div 
              className={`hidden w-0 lg:inline-block lg:w-auto`}
              onMouseOver={()=>handleMouse(true)} >
              <div id="main-menu" className={`${props.locale==='ko'? "text-lg":"text-base"}`}>
                <ul>
                  {mainMenus}
                </ul>
              </div>
            </div>
            <div className="flex items-center lg:ml-0">
              <LocaleSwticher className="mr-6 text-12px lg:mr-0"/>
              <div id="mobile-menu" className={`flex flex-col items-end ${titleBg? 'text-black':'text-white'} lg:hidden`}>
                <div id="menuIcon" onClick={handleMenuClick}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor">
                    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/>
                  </svg>
                </div>
              </div>
          </div>
        </div>
        </div>
        <div className="h-0 w-screen min-w-0 bg-gray-400 group-[.menu-hover]:h-[1px]" onMouseOver={()=>handleMouse(true)}></div>
        <div id="sub-div" 
          className={`w-screen min-w-0 flex justify-center h-0 overflow-hidden bg-[#FFFFFFF0]` +
          ` group-[.menu-hover]:h-[270px] transition-all duration-700`}
          onMouseOver={()=>handleMouse(true)}>
          <div className={`${locale==='ko'? 'lg:w-[143px]':'lg:w-[112px]'}`}></div>
          <ul className={`my-5`}>
            {subMenus}
          </ul>
          <div className='lg:w-[92px]'></div>
        </div>
      </div>
      {/*  모바일용 메뉴  */}
      <div id="mobile-menu" 
        className={`w-screen min-w-0 ${showMoblieMenu? "fixed top-0 h-auto":"h-0 hidden"} 
        transition-all duration-700 overflow-hidden min-w-0
        top-0 z-50 flex flex-col items-start bg-gray-100 w-full pb-10 pt-6`}>
        {/* 회사이름과 닫기 버튼 */}
        <div className="flex flex-row items-center justify-between w-full px-5 mb-4">
          <Link to="/" className="mr-4 text-2xl font-bold" onClick={handleClose}>SJ Energy</Link>
          <div onClick={handleClose}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#303030">
              <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
            </svg>
          </div>
        </div>
        <div className='h-[0.5px] bg-[#b7b7b7] w-full'/>
        <nav className='w-full px-6 mt-6'>
          <ul>
            {mobileMenus}
          </ul>
        </nav>
      </div>
    </header>
  );
}